import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Navigation from "./components/Details/Navigation";
import Profile from "./components/Profile";
import AboutMe from "./components/Details/AboutMe";
import Resume from "./components/Details/Resume";
import Projects from "./components/Details/Projects";
import Contact from "./components/Details/ContactMe";
import Courses from "./components/Details/Courses";

function App() {
  return (
    <>
      <BrowserRouter>
        <div className="container">
          <div className="profile">
            <Profile />
          </div>
          <div className="details">
            <div className="navigation-app-container">
              <Navigation />
            </div>
            <div className="detailContainer">
            <Routes>
                <Route path="/" element={<AboutMe />} />
                <Route path="resume" element={<Resume />} />
                <Route path="projects" element={<Projects />} />
                <Route path="contact" element={<Contact />} />
                <Route path="courses" element= {<Courses />} />
            </Routes>
            </div>
          </div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
